import "./javascripts/components/Component/Component.js";
import "./javascripts/components/Manager/Manager.js";